import React from 'react';
import {Asset, SelectionMode} from '../MediaGallery';
import ThumbnailDetailed from './ThumbnailDetailed';
import ThumbnailGrid from './ThumbnailGrid';
import {ThumbnailOverlayDisplayMode} from './ThumbnailOverlays';
import {ThumbnailSelectorProps} from './ThumbnailSelector';

export type ThumbnailLayout = 'full-frame-tiles' | 'square-tiles' | 'details-list';

export type ThumbnailProps = {
  columns?: number;
  currencyCode?: string;
  disabled?: boolean;
  expired?: boolean;
  image: Asset;
  localeString?: string;
  onDragEnd?: (event: React.DragEvent<HTMLElement>, asset: Asset) => void;
  onDragStart?: (event: React.DragEvent<HTMLElement>, asset: Asset) => void;
  onSelectPicture?: (checked: boolean, pic: any) => void;
  onTouchEnd?: (event: React.TouchEvent<HTMLElement>) => void;
  onTouchStart?: (event: React.TouchEvent<HTMLElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent, asset: Asset) => void;
  onDeleteAsset?: (id: number) => void;
  openDetailsDialog?: Function;
  selectionAppearance: ThumbnailSelectorProps['appearance'];
  selectableImages: boolean;
  selected: boolean;
  showDeleteButton?: boolean;
  showPricing?: boolean;
  showTooltips?: boolean;
  showUsage?: boolean;
  showLabel?: boolean;
  thumbnailLayout?: ThumbnailLayout;
  used: number;
  overlayDisplayMode: ThumbnailOverlayDisplayMode;
  maxSelectionReached: boolean;
  selectionMode: SelectionMode;
};

const MediaGalleryThumbnailFactory = ({...props}: ThumbnailProps) => {
  //prettier-ignore
  return <>{
      props.thumbnailLayout === 'details-list'
      ? <ThumbnailDetailed {...props} />
      : <ThumbnailGrid {...props} />
    } </>;
};

export default MediaGalleryThumbnailFactory;
